import { render, staticRenderFns } from "./ExpandableHead.vue?vue&type=template&id=77e0ca9a&"
import script from "./ExpandableHead.vue?vue&type=script&lang=js&"
export * from "./ExpandableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports